import { render, staticRenderFns } from "./MaxRank.vue?vue&type=template&id=7cf445e2&scoped=true&"
import script from "./MaxRank.vue?vue&type=script&lang=js&"
export * from "./MaxRank.vue?vue&type=script&lang=js&"
import style0 from "./MaxRank.vue?vue&type=style&index=0&id=7cf445e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf445e2",
  null
  
)

/* custom blocks */
import block0 from "./MaxRank.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports